import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from './http.service';
import { ClResultado } from '../utils/dtos/clResultado';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { clDatosToken } from '../utils/dtos/clDatosToken';


@Injectable()
export class LoginService {

  tokenName = 'Token';
  apiRest: String;
  numTrazbilidad: number;
  desdeDentro: boolean;
  usuarioAinia: string;
  passwordAinia: string;

  constructor(private httpService: HttpService, private router: Router) {
  }
  asignarUrl() {
    /*
    if (this.getDesdeDentro()) {
      this.apiRest = environment.webApiBaseDesdeDentro;
    } else {
      this.apiRest = environment.webApiBaseDesdeFuera;
    }
    */
   this.apiRest = environment.webApiBaseDesdePortal;
  }
  FinMostrarInformacion(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + '/LeidoCovid', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  validarUsuario(usu: string, pass: string, Origen: string): Promise<clDatosToken> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + '/ObtenerToken?usuario=' + usu + '&pass=' + pass + '&Origen=' + Origen,
     true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  public setDesdeDentro(valor: boolean) {
    window.sessionStorage.setItem('dentro', valor ? 'true' : 'false');
  }

  public getDesdeDentro() {
    if (window.sessionStorage.getItem('dentro') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  public setNombreEmpresa(numero: string) {
    window.sessionStorage.setItem('nombre_empresa', numero);
  }
  public setInfoCovid(info:string){
    window.sessionStorage.setItem('infoCovid',info);
  }
  public setId(numero: string) {
    window.sessionStorage.setItem('id', numero);
  }
  public getId() {
    return window.sessionStorage.getItem('id');
  }
  public setMensaje(mensaje: string) {
    window.sessionStorage.setItem('mensaje', mensaje);
  }

  public getNombreEmpresa() {
    return Number.parseInt(window.sessionStorage.getItem('nombre_empresa'));
  }

  public setNombreUsuario(nombre: string) {
    window.sessionStorage.setItem('nombre', nombre);
  }

  public setRol(rol: string) {
    window.sessionStorage.setItem('rol', rol);
  }

  public getRol() {
    return window.sessionStorage.getItem('rol');
  }

  public getNombreUsuario() {
    return window.sessionStorage.getItem('nombre');
  }

  public setToken(token: string) {
      window.sessionStorage.setItem(this.tokenName, token);
  }

  public getToken() {
      return window.sessionStorage.getItem(this.tokenName);
  }

  public clearSesion() {
      window.sessionStorage.removeItem(this.tokenName);
      window.sessionStorage.removeItem('nombre');
      window.sessionStorage.removeItem('numTraza');
      window.sessionStorage.clear();

  }

  isLoggedIn() {
    if (this.getToken() !== '' && this.getToken()) {
      return  true;
    } else { return false; }
  }

  esCliente() {
    if (this.getRol() === 'CLIENTE') {
      return  true;
    } else { return false; }
  }

  cerrarSesion() {
    this.clearSesion();
    if (!this.getDesdeDentro() && this.getRol() === 'CLIENTE') {
      this.router.navigate(['/auth/login/cliente']);
    } else {
      this.router.navigate(['/auth/login']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts